import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { Navigation } from '../navigation/nav-item.model';
import { ShellAccount, ShellBranding } from '../shell.facade';

/** The app's side panel: brand and organisation, navigation, then the account at the bottom. */
@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class SidebarComponent {
    @Input({ required: true }) branding!: ShellBranding;
    @Input({ required: true }) navigation!: Navigation;
    @Input({ required: true }) account!: ShellAccount;
    @Input({ required: true }) currentUrl = '';
    @Input() loading = false;
    @Input() languages: string[] = [];
    @Input() currentLanguage = '';
    /** Days left in the free trial, or null to hide the reminder. */
    @Input() freeTrialDaysLeft: number | null = null;
    @Input() showPoweredBy = false;
    /** A platform admin is controlling this organisation: the organisation card says so, with the way out. */
    @Input() controlling = false;

    /** Emits after a navigation entry is followed. */
    @Output() readonly navigate = new EventEmitter<void>();
    @Output() readonly languageChange = new EventEmitter<string>();
    @Output() readonly logout = new EventEmitter<void>();
    @Output() readonly contactSales = new EventEmitter<void>();
    @Output() readonly stopControlling = new EventEmitter<void>();

    readonly loadingRows = [0, 1, 2, 3, 4, 5];
}
